// Pending KRNOS view for the orb's swipe-right (Aim R → week, Today R → day).
// KRNOS reads it once on mount and clears it, then falls back to its default.
export type KrnosViewPref = 'weekly' | 'daily';
let pending: KrnosViewPref | null = null;
export function setKrnosView(v: KrnosViewPref | null): void {
  pending = v;
}
export function consumeKrnosView(): KrnosViewPref | null {
  const v = pending;
  pending = null;
  return v;
}
